import { ipsos, supuesto } from ".";

// Láminas 47 (tenencia) y 48 (tipo de compra + frecuencia de recambio), base 400/225.
// Reemplaza la lectura de la tabla `ipsos_categorias` vía getIpsosData — valores idénticos
// a los 15 registros de Chile (Perú copia el mismo dump, notas "Investigación Perú pendiente").
const P_TIENE_AUTO = "¿Tiene auto?";
const P_SEGUNDO_AUTO = "¿Tiene más de un auto en el núcleo familiar?";
const P_TIPO_COMPRA = "¿Su auto es 0km o usado?";
const P_FRECUENCIA = "¿Con qué frecuencia cambia de auto?";

export const IPSOS_AUTOMOTRIZ = {
  tieneAuto: ipsos(0.554, { lamina: 47, pregunta: P_TIENE_AUTO, base: 400 }),
  tieneSegundoAuto: ipsos(0.562, { lamina: 47, pregunta: P_SEGUNDO_AUTO, base: 225 }),
  compra0km: ipsos(0.576, { lamina: 48, pregunta: P_TIPO_COMPRA, base: 400 }),
  compraUsado: ipsos(0.424, { lamina: 48, pregunta: P_TIPO_COMPRA, base: 400 }),

  // factor = anualización del recambio (supuesto comercial derivado del rango Ipsos)
  frecuencias: {
    gamaAlta: {
      share: ipsos(0.08, { lamina: 48, pregunta: P_FRECUENCIA, base: 400, nota: "1 a 2 años" }),
      factor: supuesto(0.5, { nota: "factor de anualización, rango 1-2 años" }),
      rango: "1-2 años",
    },
    gamaMedia1: {
      share: ipsos(0.45, { lamina: 48, pregunta: P_FRECUENCIA, base: 400, nota: "3 a 4 años" }),
      factor: supuesto(0.25, { nota: "factor de anualización, rango 3-4 años" }),
      rango: "3-4 años",
    },
    gamaMedia2: {
      share: ipsos(0.34, { lamina: 48, pregunta: P_FRECUENCIA, base: 400, nota: "5 a 9 años" }),
      factor: supuesto(0.11, { nota: "factor de anualización, rango 5-9 años" }),
      rango: "5-9 años",
    },
    noCompra: {
      share: ipsos(0.13, { lamina: 48, pregunta: P_FRECUENCIA, base: 400, nota: "10+ años, no compra" }),
      factor: supuesto(0, { nota: "no compra" }),
      rango: "10+ años",
    },
  },
};

// Supuestos comerciales (USD) — precios de referencia por defecto y opciones del selector
export const PRECIOS_DEFAULT_AUTOMOTRIZ = {
  gamaAlta: {
    okm: supuesto(50000, { nota: "precio 0km gama alta de referencia" }),
    usado: supuesto(25000, { nota: "precio usado gama alta de referencia" }),
  },
  gamaMedia: {
    okm: supuesto(20000, { nota: "precio 0km gama media de referencia" }),
    usado: supuesto(10000, { nota: "precio usado gama media de referencia" }),
  },
};

export const PRECIOS_GAMA_ALTA = {
  okm: [
    supuesto(40000, { nota: "precio 0km gama alta" }),
    supuesto(50000, { nota: "precio 0km gama alta" }),
    supuesto(60000, { nota: "precio 0km gama alta" }),
  ],
  usado: [
    supuesto(20000, { nota: "precio usado gama alta" }),
    supuesto(25000, { nota: "precio usado gama alta" }),
    supuesto(30000, { nota: "precio usado gama alta" }),
  ],
};
export const PRECIOS_GAMA_MEDIA = {
  okm: [
    supuesto(15000, { nota: "precio 0km gama media" }),
    supuesto(20000, { nota: "precio 0km gama media" }),
    supuesto(25000, { nota: "precio 0km gama media" }),
  ],
  usado: [
    supuesto(8000, { nota: "precio usado gama media" }),
    supuesto(10000, { nota: "precio usado gama media" }),
    supuesto(12000, { nota: "precio usado gama media" }),
  ],
};
